import React, { Component } from "react";
import Receipt from "../components/GiftCard/CashTransactionReceipt";
import querySearch from "stringquery";

import { getGiftCardTransaction } from "../services/ReportService";

export default class GiftCardReceipt extends Component {
	constructor() {
		super();
		this.state = { reportData: null };
	}
	componentDidMount() {
		const query = querySearch(window.location.search);
		getGiftCardTransaction(query.tid, query.lang).then((res) => {
			this.setState({ reportData: res.data, urldata: query.v });
			document.title = "Gift_Card_Receipt_" + res.data.transactionNumber;
		});
	}
	render() {
		return this.state.reportData ? (
			<div style={{ height: "100%" }}>
				<Receipt
					result={this.state.reportData}
					isBankCopy={false}
					copyPrint={this.state.urldata}
				/>
				<Receipt result={this.state.reportData} isBankCopy={true} />
			</div>
		) : (
			<div></div>
		);
	}
}
